module.exports = __webpack_public_path__ + "static/media/17_l_stena_0_9.72.9d3115ab.png";